// extracted by mini-css-extract-plugin
export default {"mainMenu":"style_mainMenu__IjjXS","menuItem":"style_menuItem__FZ12M"};